import React from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const ErrorPagoModal = ({ open, onClose, onAccept }) => {
  if (!open) return null;

  return (
    <FlexContainer
      className="pos-fixed justify-center align-items-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
      }}
    >
      <FlexContainer
        className="pos-rel flex-column align-center width-300px bgWhite borderrad26 overflow-hidden"
        style={{
          boxShadow: '0px 8px 26px rgba(0,0,0,0.25)',
        }}
      >
        <FlexContainer
          className="width-100 justify-center align-items-center padt8 padr0 padb10 padl0 pos-rel"
          style={{
            background: '#0143a0',
          }}
        >
          <img
            src={require('@/style/_assets/img/image-Photoroom.png')}
            alt="Header icon"
            className="width-175px"
            style={{
              objectFit: 'contain',
            }}
          />

          <FlexContainer
            onClick={onClose}
            className="pointer justify-center align-items-center pos-abs top10 right10 width-20px height-20px bgWhite text-13"
            style={{
              borderRadius: '50%',
              color: '#0143a0',
              fontWeight: '1000',
              textShadow: '0.5px 0.5px 0px rgba(0,0,0,0.3)',
            }}
          >
            <ModalCloseIcon />
          </FlexContainer>
        </FlexContainer>

        <FlexContainer className="flex-column align-center text-center padlr26 padt26 padb22">
          <Label
            className="text-20 font-medium marb0"
            style={{
              color: '#0143a0',
              lineHeight: '1.4',
            }}
          >
            Lo sentimos, no se pudo procesar el pago en estos momentos.
          </Label>

          <Label
            className="text-20 font-regular margb26"
            style={{
              color: '#0143a0',
              lineHeight: '1.4',
            }}
          >
            Por favor vuelve a intentarlo en unos minutos; de lo contrario
            puedes llamar a nuestro Contact Center al{' '}
            <span style={{ fontWeight: '700' }}>(01) 219-0000</span>.
          </Label>

          <FlexContainer
            onClick={onAccept}
            className="pointer justify-center align-items-center borderrad10 padtb12 padlr0"
            style={{
              background: '#0143a0',
              boxShadow: '0px 2px 6px rgba(2, 59, 122, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = '#0143a0';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = '#023B7A';
            }}
          >
            <Label className="text-16 font-bold" style={{ color: '#FFF' }}>
              Aceptar
            </Label>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default ErrorPagoModal;
